import { useRef } from 'react';
const useStateRef = (state) => {
    const ref = useRef(state);
    ref.current = state;
    return ref;
};
export default useStateRef;
